
import { defineComponent, onMounted, onBeforeMount, computed, watch } from 'vue'
import { RouterView } from 'vue-router'
import { useStore, mapGetters } from 'vuex'
import {
  isAndroidNative,
  sendMessage,
  isIOSNative,
} from '@xunlei/universal-native-api'
import '@xunlei/thunder-icon-vue/dist/style.css'
import global from '@remote/store/constantStore'
import { parseSearch, isNativeApp, nativeCall } from '@remote/utils'
import { useBaseStore } from '@remote/store/base'
import { useDisk } from '@remote/store/hezi-file/disk'
import { useEnvStore } from '@remote/store/env'
import { curState } from '@remote/router'
import { setTag } from '@sentry/vue'
import { reportSwitchDevice } from '@remote/utils/logger'
import { useIsLargeViewport } from '@remote/utils/use-hooks/use-is-large-viewport'

export default defineComponent({
  name: 'App',
  components: {
    RouterView,
  },
  setup () {
    const baseStore = useBaseStore()
    const envStore = useEnvStore()
    const store = useStore()
    // 在手雷中打开调整状态栏
    if (isAndroidNative) {
      window.onPageCloseFunc = function () { }
      sendMessage(
        {
          platform: 'android', 
          name: 'xlSetActionBar', 
          params: { hideActionBar: true },
        },
        {noCallback: true},
      )
    }

    if (isIOSNative) {
      sendMessage(
        {
          platform: 'ios',
          name: 'xlHideBar',
          params: {
            show: false,
          },
        },
        { noCallback: true },
      )
    }
    onBeforeMount(() => {
      const query = parseSearch() as { [key: string]: string }
      envStore.updateEnv(query)

      const fromSpace = query.space || ''
      const runnerSpace = query.runner_space || ''
      const platform = query.platform || ''
      global.fromApp = query.fromApp || '' // ? 不知道什么情况会传 fromApp
      global.fromSpace = fromSpace

      // 这些状态要逐渐迁移到 envStore
      store.commit('update', { fromSpace })
      runnerSpace && store.commit('update', { runnerSpace })
      store.commit('update', { platform })
      store.commit('update', {
        // 只显示当前一台设备
        justOne: Number(query.justOne || query.justone || '0'),
      })
      store.dispatch('checkVersion')
    })

    const isVipRef = computed(() => {
      return store.getters['isVip']
    })

    const targetRef = computed(() => store.state?.deviceInfoWatchData?.target)

    watch(() => isVipRef, (val) => {
      if (isNativeApp()) {
        const color = val.value ? '#FEE8C5' : '#DFF1FF'
        nativeCall('configNav', false, '迅雷下载', color)
      }
    })

    watch(targetRef, () => {
      console.log('Sentry tag is set.')
      setTag('target', targetRef.value)
      const deviceInfo = store.state.deviceInfoWatchData as API_DEVICE.DeviceInfo
      setTag('userID', deviceInfo.user?.id)
      setTag('build_version', deviceInfo.build_version)
      setTag('client_version', deviceInfo.client_version)
      setTag('download_version', deviceInfo.download_version)
      setTag('privilege', deviceInfo.privilege)
      console.log('deviceInfo', JSON.stringify(deviceInfo.user))
      reportSwitchDevice()
    })

    onMounted(async () => {
      baseStore.getBaseConfig()
      window.addEventListener('popstate', () => {
        // 在这些路由下点击返回，直接关闭页面。
        const ROUTES_BACK_TO_HOME = ['/me', '/home', '/cinema', '/hezi-files', '/album']
        if (store.state.isApp && ROUTES_BACK_TO_HOME.includes(curState)) {
          store.dispatch('close')
        }
      })
    })
    useDisk()
    useIsLargeViewport()
    return { store }
  },
  computed: {
    ...mapGetters(['isVip']),
    showAuthorize (): boolean {
      return ['signin', 'signout'].includes(this.$route.query.authorize as string)
    },
  },
  async mounted () {
    this.inPCXunleiSetClassToBody()
    document.addEventListener('visibilitychange', this.onvisibilitychange)
    window.addEventListener('online', () => this.networdEnv(true))
    window.addEventListener('offline', () => this.networdEnv(false))
    window.addEventListener('message', (res) => this.onmessage(res))
  },
  unmounted () {
    window.removeEventListener('online', this.networdEnv)
    window.removeEventListener('offline', this.networdEnv)
  },
  methods: {
    inPCXunleiSetClassToBody () {
      if (window.navigator.userAgent.includes('TBC')) {
        document.body.classList.add('is-in-pc')
      }
    },
    networdEnv (bol: boolean) {
      if (bol) {
        this.store.dispatch('login')
      } else {
        this.store.commit('update', { status: 0, loading: 0 })
        if (isAndroidNative) {
          sendMessage({
            platform: 'android',
            name: 'xlShowToast',
            params: {
              message: '网络未连接',
            },
          })
        }
        this.$stat({ action: 'refresh_page_show' })
      }
    },
    onmessage (res) {
      if (res && res.data && res.data === 'close-plugin') {
        this.$router.push({
          name: 'plugin',
          query: this.$route.query,
        })
      }
      if (res && res.data && typeof res.data === 'string' && res.data !== 'undefined') {
        try {
          const data = JSON.parse(res.data)
          const platform = data.platform
          console.log(data, platform)
        } catch (e) {
          console.error(e)
        }
      }
    },
    onvisibilitychange () {
      if (document.visibilityState === 'visible') {
        if (isIOSNative) {
          sendMessage(
            {
              platform: 'ios',
              name: 'xlHideBar',
              params: {
                show: false,
              },
            },
            { noCallback: true },
          )
        }
      }
    },
  },
})
